export const ENVIROMENT = {
	BUCKET_MARKETPLACE: `https://storage.googleapis.com/pharol-marketplace`,
	EXAMPLE_HOST: 'https://jsonplaceholder.typicode.com',
	COUNTRY: process.env.REACT_APP___COUNTRY,
	BASE: process.env.REACT_APP_BASE,
	BASE_PANEL: process.env.REACT_APP_BASE_PANEL,
	ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
	DOPPLER_CONFIG: process.env.DOPPLER_CONFIG,
	DOPPLER_ENVIRONMENT: process.env.DOPPLER_ENVIRONMENT,
	DOPPLER_PROJECT: process.env.DOPPLER_PROJECT,
	BASE_BACKEND: process.env.REACT_APP_BASE_BACKEND,
	FACEBOOK_LOGIN: process.env.REACT_APP_FACEBOOK_LOGIN,
	FUNCTION_MIGRATION_PHAROL: process.env.REACT_APP_FUNCTION_MIGRATION_PHAROL,
	GOOGLE_PLACE_API: process.env.GOOGLE_PLACE_API,
	PANEL_TRACKING: process.env.REACT_APP_FUNCTION_PANEL_TRACKING,
	AGREEMENT: process.env.REACT_APP_FUNCTION_AGREEMENT,
	BANNER: process.env.REACT_APP_FUNCTION_BANNER,
	BARCODE: process.env.REACT_APP_FUNCTION_BARCODE,
	CHECKOUT: process.env.REACT_APP_FUNCTION_CHECKOUT,
	CLAIM: process.env.REACT_APP_FUNCTION_CLAIM,
	CONVERT_INTERFACE_FILE: process.env.REACT_APP_FUNCTION_CONVERT_INTERFACE_FILE,
	CUSTOM_STYLES: process.env.REACT_APP_FUNCTION_CUSTOM_STYLES,
	FRONT_COMMON: process.env.REACT_APP_FUNCTION_FRONT_COMMON,
	GENERATE_PHARMACY: process.env.REACT_APP_FUNCTION_GENERATE_PHARMACY,
	IMAGE_MANAGEMENT: process.env.REACT_APP_FUNCTION_IMAGE_MANAGEMENT,
	FUNCTION_MARKETPLACE_CONFIGURATION: process.env.REACT_APP_FUNCTION_MARKETPLACE_CONFIGURATION,
	MERCADO_PAGO_AR: process.env.REACT_APP_FUNCTION_MERCADO_PAGO_AR,
	MIGRATION_PHAROL: process.env.REACT_APP_FUNCTION_MIGRATION_PHAROL,
	MIGRATION_UPLOAD_ALGOLIA: process.env.REACT_APP_FUNCTION_MIGRATION_UPLOAD_ALGOLIA,
	NOTIFICATION_PUSH: process.env.REACT_APP_FUNCTION_NOTIFICATION_PUSH,
	NOVEDADES: process.env.REACT_APP_FUNCTION_NOVEDADES,
	PANEL_MENU: process.env.REACT_APP_FUNCTION_PANEL_MENU,
	PHARMACY_LETTERS: process.env.REACT_APP_FUNCTION_PHARMACY_LETTERS,
	PRODUCTS: process.env.REACT_APP_FUNCTION_PRODUCTS,
	PRODUCTS_EDIT: process.env.REACT_APP_FUNCTION_PRODUCTS_EDIT,
	PROMOTION: process.env.REACT_APP_FUNCTION_PROMOTION,
	PUNTO_PAGO: process.env.REACT_APP_FUNCTION_PUNTO_PAGO,
	QUOTATION: process.env.REACT_APP_FUNCTION_QUOTATION,
	RESERVE: process.env.REACT_APP_FUNCTION_RESERVE,
	SCHEDULE: process.env.REACT_APP_FUNCTION_SCHEDULE,
	SERVICES: process.env.REACT_APP_FUNCTION_SERVICES,
	SUCCESS_TRANSACTION: process.env.REACT_APP_FUNCTION_SUCCESS_TRANSACTION,
	UPLOAD_PHARMACY: process.env.REACT_APP_FUNCTION_UPLOAD_PHARMACY,
	USER: process.env.REACT_APP_FUNCTION_USER,
	GENERAL_STORAGE_IMAGES: process.env.REACT_APP_GENERAL_STORAGE_IMAGES,
	TOKEN_ANICH: process.env.REACT_APP_API_PHARMACY_TOKEN_ANICH,
	TOKEN_JVF: process.env.REACT_APP_API_PHARMACY_TOKEN_JVF,
	TOKEN_PHAROL: process.env.REACT_APP_API_PHARMACY_TOKEN_PHAROL,
	GOOGLE_LOGIN: process.env.REACT_APP_GOOGLE_LOGIN,
	IMAGE_ROUTE: process.env.REACT_APP_IMAGE_ROUTE,
	MPA_CLIENT_ID: process.env.REACT_APP_MPA_CLIENT_ID,
	SERVICE_DRUGS: process.env.REACT_APP_SERVICE_DRUGS,
	___COUNTRY: process.env.REACT_APP___COUNTRY,
	GOOGLE_MAPS_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY,
	ADDRESS: process.env.REACT_APP_ADDRESS,
	LANGUAGE: process.env.REACT_APP_LANGUAGE,
	NOTIFICATION_V2: process.env.REACT_APP_FUNCTION_NOTIFICATION_V2,
	WEB_SOCKET: process.env.REACT_APP_FUNCTION_NOTIFICATION_V2,

};
